module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" 保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.exportInfo
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.printInfo
    }
  }, [_c('i', {
    staticClass: "el-icon-printer"
  }), _vm._v(" 打印")])], 1), _vm._v(" "), _c('div', {
    staticClass: "reportInfo",
    style: ({
      height: _vm.reportInfoHeight + 'px'
    })
  }, [_c('table', {
    staticClass: "reportInfoTable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', {
    staticClass: "tableTitle"
  }, [_c('td', {
    staticClass: "textCenter",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.reportInfo.semesterName) + "试卷质量分析报告\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n                    课程名称：" + _vm._s(_vm.reportInfo.courseName) + "\n                              \n                    课程代码：" + _vm._s(_vm.reportInfo.courseCode) + "\n                              \n                    课程性质：" + _vm._s(_vm.reportInfo.courseProperty) + "\n                              \n                    学分：" + _vm._s(_vm.reportInfo.credit) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                    任课教师：" + _vm._s(_vm.reportInfo.teaName) + "\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    班级名称：" + _vm._s(_vm.reportInfo.className) + "\n                ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("考核方式：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "190px"
    },
    attrs: {
      "placeholder": "请选择考试形式",
      "clearable": ""
    },
    on: {
      "change": _vm.handleExamTypeChange
    },
    model: {
      value: (_vm.reportInfo.examTypeCode),
      callback: function($$v) {
        _vm.$set(_vm.reportInfo, "examTypeCode", $$v)
      },
      expression: "reportInfo.examTypeCode"
    }
  }, _vm._l((_vm.comboOption.examType), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("考试日期：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择考试日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.reportInfo.examDate),
      callback: function($$v) {
        _vm.$set(_vm.reportInfo, "examDate", $$v)
      },
      expression: "reportInfo.examDate"
    }
  })], 1)]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                    人数：" + _vm._s(_vm.reportInfo.statisticsInfo.stuNum) + "\n                ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v("人数")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.firstLevelNum))]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.secondLevelNum))]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.thirdLevelNum))]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fourthLevelNum))]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fifthLevelNum))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v("所占比例")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.firstLevelRatio) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.secondLevelRatio) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.thirdLevelRatio) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fourthLevelRatio) + "%")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v(_vm._s(_vm.reportInfo.statisticsInfo.fifthLevelRatio) + "%")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v("平均值")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.reportInfo.statisticsInfo.avgScore) + "\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v("标准差")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.reportInfo.statisticsInfo.standardDeviation) + "\n                ")])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "270px"
    }
  }, [_c('simpleLineChart', {
    key: _vm.chartTimestamp,
    ref: "simpleLineChart",
    staticStyle: {
      "width": "100%",
      "height": "270px"
    },
    attrs: {
      "chartData": _vm.chartData
    }
  })], 1)])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写改进措施,限500字以内",
      "rows": 8,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.reportInfo.improveMeasure),
      callback: function($$v) {
        _vm.$set(_vm.reportInfo, "improveMeasure", $$v)
      },
      expression: "reportInfo.improveMeasure"
    }
  })], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "rowspan": "4"
    }
  }, [_vm._v("\n                    试"), _c('br'), _c('br'), _vm._v("卷"), _c('br'), _c('br'), _vm._v("成"), _c('br'), _c('br'), _vm._v("绩\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("\n                    成绩等级\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n                    90 - 100"), _c('br'), _vm._v("（优秀）\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n                    80 - 89"), _c('br'), _vm._v("（良好）\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n                    70 - 79"), _c('br'), _vm._v("（中等）\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n                    60 - 69"), _c('br'), _vm._v("（及格）\n                ")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder textCenter",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("\n                    < 60"), _c('br'), _vm._v("（不及格）\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v("\n                    试"), _c('br'), _c('br'), _vm._v("卷"), _c('br'), _c('br'), _vm._v("情"), _c('br'), _c('br'), _vm._v("况"), _c('br'), _c('br'), _vm._v("分"), _c('br'), _c('br'), _vm._v("析\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "tableBorder textCenter"
  }, [_vm._v("\n                    改"), _c('br'), _c('br'), _vm._v("进"), _c('br'), _c('br'), _vm._v("措"), _c('br'), _c('br'), _vm._v("施\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "height": "50px"
    }
  }, [_c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("系部主任（签字）：")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("教研室主任（签字）：")]), _vm._v(" "), _c('td', {
    staticClass: "tableBorder",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("任课教师（签字）：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n                    备注：此表连同试卷装订存放。\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29d46d20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/statistics/examQualityAnalysis.vue
// module id = 1797
// module chunks = 502